import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import chatBg from '../assets/Group.png';
import heroCard from '../assets/herocard.png';

export default function HeroSection() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleMediaChange = (e) => setIsMobile(e.matches);
    handleMediaChange(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaChange);
    return () => mediaQuery.removeEventListener('change', handleMediaChange);
  }, []);

  return (
    <section
      style={{
        ...styles.hero,
        flexDirection: isMobile ? 'column' : 'row',
        height: isMobile ? 'auto' : '752px',
        padding: isMobile ? '0' : '4rem 120px',
        justifyContent: isMobile ? 'flex-start' : 'space-between',
      }}
    >
      {isMobile ? (
        <div style={styles.mobileWrapper}>
          <div style={styles.mobileBlueBox}>
            <div style={styles.mobileContent}>
              <h1 style={{ ...styles.mobileTitle, fontSize: '28px', marginTop: '26px' }}>
                Find Your Perfect <span style={styles.mobileHighlight}>Credit</span> <br />
                <span style={styles.mobileHighlight}>Card</span>{' '}
                <span style={styles.mobileMatch}>Match</span>
              </h1>
              <p
                style={{
                  ...styles.mobileSubtitle,
                  fontSize: '18px',
                  lineHeight: '28px',
                }}
              >
                Discover the best credit cards tailored to your spending habits, lifestyle, and financial goals.
              </p>
              <button style={styles.mobileButton} onClick={() => navigate('/credit-cards')}>
                BROWSE CARDS
              </button>
            </div>

            <img src={heroCard} alt="Hero Cards" style={styles.mobileImage} />
          </div>
        </div>
      ) : (
        <>
          <div style={styles.left}>
            <h1 style={styles.title}>
              <span style={styles.titleLine}>Find Your Perfect</span>
              <span style={styles.titleLine}>
                <span style={styles.titleHighlight}>Credit Card</span>
                <span style={styles.titleMatch}> Match</span>
              </span>
            </h1>

            <p style={styles.subtitle}>
              Discover the best credit cards tailored to your spending habits, lifestyle, and financial goals.
            </p>
            <button style={styles.browseBtn} onClick={() => navigate('/credit-cards')}>
              BROWSE CARDS
            </button>
          </div>

          <div style={styles.right}>
            <img
              src={heroCard}
              alt="Hero Cards"
              style={{
                width: '602.992px',
                height: '574px',
                mixBlendMode: 'plus-lighter',
                flexShrink: 0,
                marginBottom: '97px',
                alignSelf: 'center',
              }}
            />
          </div>
        </>
      )}
    </section>
  );
}

const styles = {
  hero: {
    width: '100vw',
    boxSizing: 'border-box',
    background: `#1D4094 url(${chatBg}) no-repeat center/cover`,
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
  },
  left: {
    flex: '0 0 500px',
    textAlign: 'left',
  },
  title: {
    margin: 0,
  },
  titleLine: {
    display: 'block',
    fontFamily: 'Funnel Sans',
    fontSize: '48px',
    fontWeight: 700,
    lineHeight: '72px',
  },
  titleHighlight: {
    color: '#55B1F4',
  },
  titleMatch: {
    color: '#FFF',
  },
  subtitle: {
    fontSize: '18px',
    lineHeight: 1.5,
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  browseBtn: {
    display: 'inline-block',
    padding: '0.75rem 2.8rem',
    backgroundColor: '#fff',
    color: '#1E3FA6',
    border: 'none',
    borderRadius: 4,
    fontWeight: 700,
    cursor: 'pointer',
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  mobileWrapper: {
    width: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
  },
  mobileBlueBox: {
    backgroundColor: '#1D4094',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '3rem 1.25rem 3rem 1.25rem',
    textAlign: 'left',
    boxSizing: 'border-box',
  },
  mobileContent: {
    width: '100%',
    zIndex: 2,
  },
  mobileTitle: {
    fontFamily: 'Funnel Sans',
    fontWeight: 700,
    lineHeight: '38px',
    margin: 0,
    color: '#fff',
  },
  mobileHighlight: {
    color: '#55B1F4',
  },
  mobileMatch: {
    color: '#fff',
  },
  mobileSubtitle: {
    marginTop: '1rem',
    marginBottom: '1.5rem',
    color: '#fff',
  },
  mobileButton: {
    marginTop: '2.5rem',
    marginBottom: '2.5rem',
    padding: '12px 20px',
    width: '90%',
    margin: '2rem 0.8rem',

    fontSize: '15px',
    fontWeight: 700,
    backgroundColor: '#fff',
    color: '#1E3FA6',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  mobileImage: {
    marginTop: '2.5rem',
    width: '100%',
    maxWidth: '280px',
    height: 'auto',
    objectFit: 'contain',
    display: 'block',
    alignSelf: 'center',
    zIndex: 1,
    mixBlendMode: 'plus-lighter',
  },
};
